import { ActionTypes } from 'redux/utils/List'

export default {
    ...ActionTypes('REPORT'),
    VALIDATE_FILTER: 'VALIDATE_REPORT_FILTER'
}